import React from "react";
import GreenBg from "../../../../../public/images/vigo-green-bg.svg";
import {Image} from "./VigoGreenBG.styles";

export const VigoGreenBG = () => {
    return <Image src={GreenBg} alt="Vigo Green Background" />;
};
